import { TVariant } from './typography.interface'

export const config: Record<TVariant, string> = {
	time: 'text-[12px] font-normal leading-[24px] uppercase font-jetbrains',
	h2: 'text-[16px] font-medium leading-[32px]',
	text: 'text-[14px] font-normal leading-[20px]',
	'text-semibold': 'text-[14px] font-semibold leading-[22px]',
	'text-large': 'text-[16px] font-normal leading-[32px]',
	'text-xlarge': 'text-[24px] font-semibold leading-[32px]'
}
